import { render, staticRenderFns } from "./KeyInput.vue?vue&type=template&id=2b9c59f9&scoped=true"
import script from "./KeyInput.vue?vue&type=script&lang=ts"
export * from "./KeyInput.vue?vue&type=script&lang=ts"
import style0 from "./KeyInput.vue?vue&type=style&index=0&id=2b9c59f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c59f9",
  null
  
)

export default component.exports